export type Shortcut = {
  keys: string;
  description: string;
};

export const KEYBOARD_SHORTCUTS = {
  NEXT_TAB:                 { keys: 'alt+rightarrow',  description: 'Go to next tab' },
  PREV_TAB:                 { keys: 'alt+minus',  description: 'Go to previous tab' },
  DOWNLOAD_PRIMARY:         { keys: 'alt+d',    description: 'Download primary loadsheet' },
  DOWNLOAD_SECONDARY:       { keys: 'alt+p',    description: 'Download secondary loadsheet' },
  ACTION_ADD_MODAL_PRIMARY: { keys: 'alt+n', description: 'Open add modal for primary action' },
  ACTION_ADD_MODAL_SECONDARY: { keys: 'alt+m', description: 'Open add modal for secondary action' },
  ACTION_ENABLE_EDIT:       { keys: 'alt+e',      description: 'Enable action editing' },
  ACTION_CANCEL:            { keys: 'esc',      description: 'Close current modal' },
  MODAL_CANCEL:            { keys: 'alt+q',      description: 'Close current modal' },
  ACTION_CONFIRM:           { keys: 'enter',    description: 'Confirm action' },
  ACTION_SAVE:              { keys: 'alt+s',      description: 'Save current changes' },

  ACTION_TOGGLE_ACCORDION_PRIMARY: { keys: 'alt+h', description: 'Show/hide completed actions' },
  ACTION_TOGGLE_ACCORDION_SECONDARY: { keys: 'alt+shift+h', description: 'Show/hide completed actions' },

  TABLE_EXPAND_COLLAPSE_ROW: { keys: 'alt+t', description: 'Expand/collapse table row' },

  
  HIGHLIGHT_COLOR_GREEN: { keys: 'alt+g', description: 'Highlight green KPIs' },
  HIGHLIGHT_COLOR_AMBER: { keys: 'alt+a', description: 'Highlight amber KPIs' },
  HIGHLIGHT_COLOR_RED:   { keys: 'alt+r', description: 'Highlight red KPIs' },
  HIGHLIGHT_COLOR_ORANGE:   { keys: 'alt+o', description: 'Highlight orange KPIs' },
} as const;